import { useEffect, useState, useCallback } from 'react';
import api from '../lib/api';
import { MapPin, Users, Trophy, Phone, TrendingUp } from 'lucide-react';

const fmt = (n) => `$${Number(n).toLocaleString('es-VE', { minimumFractionDigits: 0, maximumFractionDigits: 0 })}`;

function TerritoryCard({ zona }) {
  const quotaColor = zona.cuota_progreso >= 80 ? 'var(--green)' : zona.cuota_progreso >= 50 ? 'var(--amber)' : 'var(--red)';
  const clampedPct = Math.min(zona.cuota_progreso, 100);

  return (
    <div data-testid={`territory-card-${zona.id}`} className="territory-card">
      <div className="tc-header">
        <div className="tc-icon"><MapPin size={18} /></div>
        <div>
          <h3 className="tc-name">{zona.nombre}</h3>
          <span className="tc-agent">{zona.agente_nombre || 'Sin asignar'}</span>
        </div>
      </div>
      <div className="tc-stats">
        <div className="tc-stat"><Users size={14} /><div><span className="tc-stat-val">{zona.leads}</span><span className="tc-stat-label">Leads</span></div></div>
        <div className="tc-stat"><Trophy size={14} /><div><span className="tc-stat-val">{zona.ganados}</span><span className="tc-stat-label">Ganados</span></div></div>
        <div className="tc-stat"><Phone size={14} /><div><span className="tc-stat-val">{zona.llamadas_hoy}</span><span className="tc-stat-label">Llamadas</span></div></div>
        <div className="tc-stat"><TrendingUp size={14} /><div><span className="tc-stat-val">{zona.conversion}%</span><span className="tc-stat-label">Conversion</span></div></div>
      </div>
      <div className="tc-quota">
        <div className="tc-quota-header">
          <span>Progreso vs cuota</span>
          <span style={{ color: quotaColor, fontWeight: 700 }}>{zona.cuota_progreso}%</span>
        </div>
        <div className="tc-quota-track">
          <div className="tc-quota-fill" style={{ width: `${clampedPct}%`, background: quotaColor }} />
        </div>
        <div className="tc-quota-footer">
          <span>{fmt(zona.monto_ganado)} ganado</span>
          <span>Meta: {fmt(zona.cuota_mensual)}</span>
        </div>
      </div>
    </div>
  );
}

export default function TerritoriesPage() {
  const [territories, setTerritories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const fetchTerritories = useCallback(async () => {
    try {
      const res = await api.get('/territories');
      setTerritories(res.data);
    } catch (err) {
      setError(err.response?.data?.detail || 'Error al cargar territorios');
    }
    setLoading(false);
  }, []);

  useEffect(() => { fetchTerritories(); }, [fetchTerritories]);

  if (loading) return <div className="page-loading">Cargando territorios...</div>;
  if (error) return <div className="page-loading">{error}</div>;

  return (
    <div data-testid="territories-page" className="territories-page">
      {territories.length === 0 ? (
        <div className="page-loading">No hay territorios configurados</div>
      ) : (
        <div className="territory-grid">
          {territories.map(zona => <TerritoryCard key={zona.id} zona={zona} />)}
        </div>
      )}
    </div>
  );
}
